import { Injectable } from "@angular/core";
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Route,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { SiAuthenticationService } from "@strategic-insights/ng-authentication";
import { SiDataService } from "./services/si-data.service";

@Injectable({
  providedIn: "root",
})
export class SiCustomerGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private siDataService: SiDataService,
    private siAuthenticationService: SiAuthenticationService,
    private router: Router
  ) {}

  /**
   * Activation function for authentication
   * @param next
   * @param state
   * @returns boolean
   */
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  /**
   * Activation function for authentication
   * @param route
   * @param state
   * @returns activate child
   */
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }

  // Observable<boolean>
  /**
   * checks if can load the page
   * @param route
   * @returns boolean
   */
  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    const self = this;
    if (
      self.siAuthenticationService.authStatus.getValue() &&
      (this.siAuthenticationService.getWebToken() ||
        this.siAuthenticationService.getAuthToken())
    ) {
      if (route["path"].includes("/")) {
        if (
          this.siDataService
            .getSubTabMapping()
            .map((subTab) => subTab["path"])
            .indexOf(route["path"].split("/")[1]) !== -1
        ) {
          return true;
        } else {
          self.siAuthenticationService.logout().subscribe({ next: () => {} });
          return false;
        }
      } else {
        if (
          this.siDataService
            .getTabMapping()
            .map((tab) => tab["path"])
            .indexOf(route["path"]) !== -1
        ) {
          return true;
        } else {
          self.siAuthenticationService.logout().subscribe({ next: () => {} });
          return false;
        }
      }
    } else {
      this.siAuthenticationService.logout().subscribe({ next: () => {} });

      return false;
    }
  }
}
